module.exports = __webpack_public_path__ + "static/media/credit-card-icons.6c80db2b.png";